import React, { useEffect, useState } from 'react';
import './App.css';

import { SNACKBAR_TIME, SPLASH_TIME } from './request/values';

import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import useMember from './components/useMember';

import Splash from './components/Splash';
import Login from './components/Login';
import FindPassword from './components/FindPassword';
import FindId from './components/FindId';
import SetPassword from './components/SetPassword';
import AuthAll from './components/auth/AuthAll';
import AuthEmail from './components/auth/Email';
import AuthPassword from './components/auth/Password';
import PersonalInfo from './components/auth/PersonalInfo';
import ClassEnter from './components/ClassEnter';
import CompanyAction from './components/CompanyAction';
import CompanyFoundation from './components/CompanyFoundation';
import CompanyTypeSelection from './components/CompanyTypeSelection';
import CompanyList from './components/CompanyList';
import CompanyAppStandBy from './components/CompanyAppStandBy';
import CompanyAppList from './components/CompanyAppList';
import CompanyEditMember from './components/CompanyEditMember';
import CompanyAsset from './components/CompanyAsset';

import OperLogin from './components/oper/OperLogin';
import OperJoin from './components/oper/OperJoin';
import OperCompanyList from './components/oper/OperCompanyList';
import OperProgress from './components/oper/OperProgress';
import OperDecompositionAppList from './components/oper/OperDecompositionAppList';
import OperClassRun from './components/oper/OperClassRun';
import OperOpenRanking from './components/oper/OperOpenRanking';
import OperPassword from './components/oper/OperPassword';

import LoanList from './components/LoanList';
import QuestList from './components/QuestList';
import CompanyInfo from './components/CompanyInfo';
import LicenseList from './components/LicenseList';
import MaterialList from './components/MaterialList';
import MaterialPurchase from './components/material/Material';
import MaterialSale from './components/MaterialSale';
import MaterialSaleSheet from './components/MaterialSaleSheet';
import MaterialOrderList from './components/material/MaterialOrderList';
import MaterialOrderListTwo from './components/material/MaterialOrderList2';
import MaterialOrderSheet from './components/material/MaterialOrderSheet';

import ProductSale from './components/product/ProductList';
import ProductPurchase from './components/product/ProductPurchase';
import ProductPurchaseList from './components/product/ProductPurchaseList';
import ProducitonList from './components/product/ProductionList';
import ProductList from './components/product/ProductList';
import ProductOrderList from './components/product/ProductOrderList';
import ProductOrderList2 from './components/product/ProductOrderList2';

import Test from './components/Test';
import HeaderBar, {
    OperatorHeaderBar,
    DistributionHeaderBar,
    OperHeaderBar,
} from './components/header/HeaderBar';
import ManualView from './components/product/ManualView';
import LicenseManual from './components/LicenseManual';
import Setting from './components/Setting';
import QnA from './components/QnA';
import { useCookies } from 'react-cookie';
import { SnackbarProvider } from 'notistack';
import { SnackbarCloseButton } from './components/SnackBar';
import { makeStyles } from '@material-ui/core';
import Privacy from './components/privacy';
import DeleteUserAccount from './components/DeleteUserAccount';

import AdminLogin from './components/adminLogin';
import AdminSignin from './components/adminSignin';
import SubAdminManageClass from './components/sub_admin/subAdminManageClass';
import SubAdminClassList from './components/sub_admin/subAdminClassList';
import SubAdminClassInfo from './components/sub_admin/subAdminClassInfo';
import SubAdminCreateClass from './components/sub_admin/subAdminCreateClass';
import SubAdminClassManageNav from './components/sub_admin/subAdminClassManageNav';
import SubAdminClassRun from './components/sub_admin/subAdminClassRun';
import SubAdminClassMember from './components/sub_admin/subAdminClassMember';
import SubAdminModifyClass from './components/sub_admin/subAdminModifyClass';
import SubAdminOpenRanking from './components/sub_admin/subAdminOpenRanking';
import SubAdminOperList from './components/sub_admin/subAdminOperList';

import HeadAdminLogin from './components/headAdminLogin';
import HeadAdminClassList from './components/head_admin/headAdminClassList';
import HeadAdminClassManageNav from './components/head_admin/headAdminClassManageNav';
import HeadAdminManageClass from './components/head_admin/headAdminManageClass';
import HeadAdminClassMember from './components/head_admin/headAdminClassMember';
import HeadAdminMemberList from './components/head_admin/headAdminMemberList';
import HeadAdminAccountManage from './components/head_admin/headAdminAccountManage';
import HeadAdminMaterialList from './components/head_admin/headAdminMaterialList';
import HeadAdminLicenseList from './components/head_admin/headAdminLicenseList';
import HeadAdminCreateClass from './components/head_admin/headAdminCreateClass';
import HeadAdminAddMaterial from './components/head_admin/headAdminAddMaterial';
import HeadAdminAddLicense from './components/head_admin/headAdminAddLicense';
import HeadAdminClassRun from './components/head_admin/headAdminClassRun';
import HeadAdminOpenRanking from './components/head_admin/headAdminOpenRanking';
import HeadAdminModifyClass from './components/head_admin/headAdminModifyClass';
import MaterialLoan from './components/MaterialLoan';
import MaterialLoanSheet from './components/MaterialLoanSheet';
import MaterialLoanList from './components/MaterialLoanList';

import HeaderEmptyLayout from './components/commonStyles/headerEmpty/HeaderEmptyLayout';
import Layout from './components/commonStyles/headerContain/Layout';
import useGlobalStyles from './components/commonStyles/globalStyles';
import OperationLayout from './components/commonStyles/headerContain/OperationLayout';

const useStyles = makeStyles({
    snackBar: {
        '& .SnackbarItem-action-*': {
            paddingLeft: 0,
        },
        '& > #notistack-snackbar': {
            '&:hover ~ $b': {
                backgroundColor: '#ccc',
            },
        },
    },
});

export interface iMember {
    email: string | null;
    classCode: string | null;
    companyNum: number | null;
    name: string | null;
    companyType: string | null;
}
/*
function setScreenSize() {
  let vh = window.innerHeight * 0.01;

  console.log('setScreenSize')
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}
*/
// setScreenSize();

function App(props: any) {
    //const history = useHistory();
    const classes = useStyles();
    const [cookies, setCookie, removeCookie] = useCookies();
    const { member, setMember, deleteMember } = useMember();
    const [loading, setLoading] = useState(false);
    const { token } = props;
    useGlobalStyles();

    console.log('in App token??', token);

    useEffect(() => {
        console.log('cookie? ', cookies['access']);
        if (cookies['access'] === undefined) {
            deleteMember();
        }

        if (member == null) {
            setTimeout(() => {
                setLoading(true);
            }, SPLASH_TIME);
        } else {
            setLoading(true);
        }
    }, []);

    useEffect(() => {
        if (window.ReactNativeWebView) {
            console.log('to rn in app!!');
            window.ReactNativeWebView.postMessage('test in app');
        }
    }, []);

    if (!loading) {
        return <Splash />;
    }

    //회원가입 전 페이지
    if (!member) {
        console.log('before login');
        return (
            <SnackbarProvider
                maxSnack={3}
                autoHideDuration={SNACKBAR_TIME}
                style={{
                    fontSize: '3vw',
                }}
                className={classes.snackBar}
                // action={key => <SnackbarCloseButton key={key} />}
                action={(key) => SnackbarCloseButton(key)}
            >
                <div style={{ backgroundColor: '#ffffff' }}>
                    <BrowserRouter>
                        <Switch>
                            <Route
                                exact
                                path="/"
                                component={() => (
                                    <HeaderEmptyLayout isBackground={true}>
                                        <Login
                                            member={member}
                                            setMember={setMember}
                                            token={token}
                                        />
                                    </HeaderEmptyLayout>
                                )}
                            ></Route>
                            <Route
                                path="/findPassword"
                                component={() => (
                                    <HeaderEmptyLayout isBackground={true}>
                                        <FindPassword
                                            member={member}
                                            setMember={setMember}
                                            token={token}
                                        />
                                    </HeaderEmptyLayout>
                                )}
                            ></Route>
                            <Route
                                path="/findId"
                                component={() => (
                                    <HeaderEmptyLayout isBackground={true}>
                                        <FindId
                                            member={member}
                                            setMember={setMember}
                                            token={token}
                                        />
                                    </HeaderEmptyLayout>
                                )}
                            ></Route>
                            <Route
                                path="/setPassword"
                                component={() => (
                                    <HeaderEmptyLayout isBackground={true}>
                                        <SetPassword
                                            member={member}
                                            setMember={setMember}
                                            token={token}
                                        />
                                    </HeaderEmptyLayout>
                                )}
                            ></Route>
                            <Route
                                path="/authAll"
                                component={() => (
                                    <HeaderEmptyLayout isBackground={true}>
                                        <AuthAll
                                            member={member}
                                            setMember={setMember}
                                            token={token}
                                        />
                                    </HeaderEmptyLayout>
                                )}
                            ></Route>
                            <Route
                                path="/email"
                                component={() => (
                                    <HeaderEmptyLayout isBackground={true}>
                                        <AuthEmail
                                            member={member}
                                            setMember={setMember}
                                        />
                                    </HeaderEmptyLayout>
                                )}
                            ></Route>
                            <Route
                                path="/password"
                                component={() => (
                                    <HeaderEmptyLayout isBackground={true}>
                                        <AuthPassword
                                            member={member}
                                            setMember={setMember}
                                        />
                                    </HeaderEmptyLayout>
                                )}
                            ></Route>
                            <Route
                                path="/personalInfo"
                                component={() => (
                                    <HeaderEmptyLayout isBackground={true}>
                                        <PersonalInfo
                                            member={member}
                                            setMember={setMember}
                                            token={token}
                                        />
                                    </HeaderEmptyLayout>
                                )}
                            ></Route>

                            <Route
                                exact
                                path="/operation"
                                component={() => (
                                    <OperLogin
                                        oper={member}
                                        setOper={setMember}
                                    />
                                )}
                            ></Route>
                            <Route
                                path="/operation/join"
                                component={() => (
                                    <OperJoin
                                        oper={member}
                                        setOper={setMember}
                                    />
                                )}
                            ></Route>
                            <Route
                                path="/operation/password"
                                component={() => (
                                    <OperPassword
                                        oper={member}
                                        setOper={setMember}
                                    />
                                )}
                            ></Route>

                            <Route
                                exact
                                path="/admin"
                                component={() => (
                                    <AdminLogin
                                        member={member}
                                        setMember={setMember}
                                        token={token}
                                    />
                                )}
                            ></Route>
                            <Route
                                exact
                                path="/signin"
                                component={() => (
                                    <AdminSignin
                                        member={member}
                                        setMember={setMember}
                                    />
                                )}
                            ></Route>

                            <Route
                                exact
                                path="/headadmin"
                                component={() => (
                                    <HeadAdminLogin
                                        member={member}
                                        setMember={setMember}
                                        token={token}
                                    />
                                )}
                            ></Route>
                            <Route
                                exact
                                path="/privacy"
                                component={() => <Privacy />}
                            ></Route>
                            <Route
                                exact
                                path="/*"
                                component={() => (
                                    <Login
                                        member={member}
                                        setMember={setMember}
                                        token={token}
                                    />
                                )}
                            ></Route>
                            <Route
                                path="/test"
                                component={() => <Test member={member} />}
                            />
                        </Switch>
                    </BrowserRouter>
                </div>
            </SnackbarProvider>
        );
        //앱 내 운영진 페이지
    } else if (member.type === 'oper') {
        return (
            <SnackbarProvider
                maxSnack={3}
                autoHideDuration={SNACKBAR_TIME}
                style={{
                    fontSize: '3vw',
                }}
                className={classes.snackBar}
                // action={key => <SnackbarCloseButton key={key} />}
                action={(key) => SnackbarCloseButton(key)}
            >
                <div style={{ backgroundColor: '#ffffff' }}>
                    <BrowserRouter>
                        <Switch>
                            {!member.classCode && (
                                <Redirect exact from="/" to="/ClassEnter" />
                            )}
                            {!member.classCode && (
                                <Route
                                    path="/ClassEnter"
                                    component={() => (
                                        <HeaderEmptyLayout>
                                            <ClassEnter
                                                member={member}
                                                setMember={setMember}
                                                deleteMember={deleteMember}
                                            />
                                        </HeaderEmptyLayout>
                                    )}
                                />
                            )}
                            <Route
                                exact
                                path="/setting"
                                component={() => (
                                    <HeaderEmptyLayout>
                                        <Setting
                                            member={member}
                                            setMember={setMember}
                                            deleteMember={deleteMember}
                                        />
                                    </HeaderEmptyLayout>
                                )}
                            />
                            <Route
                                exact
                                path="/qna"
                                component={() => (
                                    <HeaderEmptyLayout>
                                        <QnA member={member} />
                                    </HeaderEmptyLayout>
                                )}
                            />
                            <Route
                                exact
                                path="/deleteUserAccount"
                                component={() => (
                                    <HeaderEmptyLayout isBackground={true}>
                                        <DeleteUserAccount
                                            member={member}
                                            setMember={setMember}
                                            deleteMember={deleteMember}
                                        />
                                    </HeaderEmptyLayout>
                                )}
                            />
                            <Route
                                path="/operation/ClassRun"
                                component={() => <OperClassRun oper={member} />}
                            />
                            <Route
                                path="/operation/OpenRanking"
                                component={() => (
                                    <OperOpenRanking oper={member} />
                                )}
                            />
                            <OperationLayout oper={member}>
                                <Switch>
                                    <Route
                                        exact
                                        path="/"
                                        render={() => (
                                            <Redirect to="/operation/company/list" />
                                        )}
                                    />
                                    <Route
                                        path="/operation/company/list"
                                        render={() => (
                                            <OperCompanyList oper={member} />
                                        )}
                                    />
                                    <Route
                                        path="/operation/progress"
                                        render={() => (
                                            <OperProgress oper={member} />
                                        )}
                                    />
                                    <Route
                                        path="/operation/decomposition/appList"
                                        render={() => (
                                            <OperDecompositionAppList
                                                oper={member}
                                            />
                                        )}
                                    />
                                </Switch>
                            </OperationLayout>

                            <Switch></Switch>
                        </Switch>
                    </BrowserRouter>
                </div>
            </SnackbarProvider>
        );
        //운영자 페이지
    } else if (member.type === 'subAdmin') {
        return (
            <SnackbarProvider
                maxSnack={3}
                autoHideDuration={SNACKBAR_TIME}
                style={{
                    fontSize: '3vw',
                }}
                className={classes.snackBar}
                // action={key => <SnackbarCloseButton key={key} />}
                action={(key) => SnackbarCloseButton(key)}
            >
                <div style={{ backgroundColor: '#ffffff' }}>
                    <BrowserRouter>
                        <Switch>
                            {
                                <Redirect
                                    exact
                                    from="/admin"
                                    to="/subAdminClassList"
                                />
                            }
                            <Route
                                exact
                                path="/subAdminClassList"
                                component={() => (
                                    <SubAdminClassList
                                        member={member}
                                        deleteMember={deleteMember}
                                    />
                                )}
                            />
                            <Route
                                exact
                                path="/subAdminCreateClass"
                                component={() => (
                                    <SubAdminCreateClass member={member} />
                                )}
                            />
                            <Route
                                exact
                                path="/subAdminClassManage"
                                component={() => (
                                    <SubAdminManageClass
                                        member={member}
                                        deleteMember={deleteMember}
                                    />
                                )}
                            />
                            <Route
                                path="/subAdminClassManageNav"
                                component={() => (
                                    <SubAdminClassManageNav
                                        member={member}
                                        deleteMember={deleteMember}
                                    />
                                )}
                            />
                            <Route
                                path="/subAdminClassInfo"
                                component={() => (
                                    <SubAdminClassInfo member={member} />
                                )}
                            />
                            <Route
                                path="/subAdminClassRun"
                                component={() => (
                                    <SubAdminClassRun member={member} />
                                )}
                            />
                            <Route
                                path="/subAdminModifyClass"
                                component={() => (
                                    <SubAdminModifyClass member={member} />
                                )}
                            />
                            <Route
                                path="/subAdminClassMember"
                                component={() => (
                                    <SubAdminClassMember member={member} />
                                )}
                            />
                            <Route
                                path="/subAdminOpenRanking"
                                component={() => (
                                    <SubAdminOpenRanking member={member} />
                                )}
                            />
                            <Route
                                exact
                                path="/subAdminOperList"
                                component={() => (
                                    <SubAdminOperList member={member} />
                                )}
                            />
                        </Switch>
                    </BrowserRouter>
                </div>
            </SnackbarProvider>
        );
        //관리자 페이지
    } else if (member.type === 'headadmin') {
        return (
            <SnackbarProvider
                maxSnack={3}
                autoHideDuration={SNACKBAR_TIME}
                style={{
                    fontSize: '3vw',
                }}
                className={classes.snackBar}
                // action={key => <SnackbarCloseButton key={key} />}
                action={(key) => SnackbarCloseButton(key)}
            >
                <div style={{ backgroundColor: '#ffffff' }}>
                    <BrowserRouter>
                        <Switch>
                            {
                                <Redirect
                                    exact
                                    from="/headadmin"
                                    to="/headAdminClassList"
                                />
                            }
                            <Route
                                path="/headAdminMemberList"
                                component={() => (
                                    <HeadAdminMemberList
                                        member={member}
                                        deleteMember={deleteMember}
                                    />
                                )}
                            />

                            <Route
                                exact
                                path="/headAdminClassList"
                                component={() => (
                                    <HeadAdminClassList
                                        member={member}
                                        deleteMember={deleteMember}
                                    />
                                )}
                            />
                            <Route
                                path="/headAdminCreateClass"
                                component={() => (
                                    <HeadAdminCreateClass member={member} />
                                )}
                            />

                            <Route
                                exact
                                path="/headAdminClassManage"
                                component={() => (
                                    <HeadAdminManageClass
                                        member={member}
                                        deleteMember={deleteMember}
                                    />
                                )}
                            />
                            <Route
                                path="/headAdminClassManageNav"
                                component={() => (
                                    <HeadAdminClassManageNav
                                        member={member}
                                        deleteMember={deleteMember}
                                    />
                                )}
                            />
                            <Route
                                path="/headAdminClassMember"
                                component={() => (
                                    <HeadAdminClassMember member={member} />
                                )}
                            />

                            <Route
                                exact
                                path="/headAdminMaterialList"
                                component={() => (
                                    <HeadAdminMaterialList
                                        member={member}
                                        deleteMember={deleteMember}
                                    />
                                )}
                            />
                            <Route
                                path="/headAdminAddMaterial"
                                component={() => (
                                    <HeadAdminAddMaterial member={member} />
                                )}
                            />

                            <Route
                                exact
                                path="/headAdminLicenseList"
                                component={() => (
                                    <HeadAdminLicenseList
                                        member={member}
                                        deleteMember={deleteMember}
                                    />
                                )}
                            />
                            <Route
                                path="/headAdminAddLicense"
                                component={() => (
                                    <HeadAdminAddLicense member={member} />
                                )}
                            />

                            <Route
                                path="/headAdminClassRun"
                                component={() => (
                                    <HeadAdminClassRun member={member} />
                                )}
                            />
                            <Route
                                path="/headAdminModifyClass"
                                component={() => (
                                    <HeadAdminModifyClass member={member} />
                                )}
                            />
                            <Route
                                path="/headAdminOpenRanking"
                                component={() => (
                                    <HeadAdminOpenRanking member={member} />
                                )}
                            />

                            <Route
                                exact
                                path="/headAdminAccountManage"
                                component={() => (
                                    <HeadAdminAccountManage
                                        member={member}
                                        deleteMember={deleteMember}
                                    />
                                )}
                            />
                        </Switch>
                    </BrowserRouter>
                </div>
            </SnackbarProvider>
        );
        //회원가입 후 클래스 입장
    } else if (
        !member.classCode ||
        !member.companyNum ||
        member.companyNum <= 0 ||
        member.companyNum === null
    ) {
        return (
            <SnackbarProvider
                maxSnack={3}
                autoHideDuration={SNACKBAR_TIME}
                style={{
                    fontSize: '3vw',
                }}
                className={classes.snackBar}
                action={(key) => SnackbarCloseButton(key)}
            >
                <div style={{ backgroundColor: '#ffffff' }}>
                    <BrowserRouter>
                        <HeaderEmptyLayout>
                            <Switch>
                                {!member.classCode && (
                                    <Redirect exact from="/" to="/ClassEnter" />
                                )}
                                {!member.classCode && (
                                    <Route
                                        path="/ClassEnter"
                                        component={() => (
                                            <ClassEnter
                                                member={member}
                                                setMember={setMember}
                                                deleteMember={deleteMember}
                                            />
                                        )}
                                    />
                                )}
                                {(member.companyNum === 0 ||
                                    member.companyNum === null) && (
                                    <Route
                                        path="/CompanyAction"
                                        component={() => (
                                            <CompanyAction
                                                member={member}
                                                setMember={setMember}
                                            />
                                        )}
                                    />
                                )}
                                {(member.companyNum === 0 ||
                                    member.companyNum === null) && (
                                    <Route
                                        path="/CompanyTypeSelection"
                                        component={() => (
                                            <CompanyTypeSelection
                                                member={member}
                                                setMember={setMember}
                                            />
                                        )}
                                    />
                                )}
                                {(member.companyNum === 0 ||
                                    member.companyNum === null) && (
                                    <Route
                                        path="/CompanyFoundation"
                                        component={() => (
                                            <CompanyFoundation
                                                member={member}
                                                setMember={setMember}
                                            />
                                        )}
                                    />
                                )}
                                {(member.companyNum === 0 ||
                                    member.companyNum === null) && (
                                    <Route
                                        path="/CompanyList"
                                        component={() => (
                                            <CompanyList
                                                member={member}
                                                setMember={setMember}
                                            />
                                        )}
                                    />
                                )}
                                {(member.companyNum === 0 ||
                                    member.companyNum === null) && (
                                    <Redirect
                                        exact
                                        from="*"
                                        to="/CompanyAction"
                                    ></Redirect>
                                )}
                                {member.companyNum === -1 && (
                                    <Redirect
                                        exact
                                        from="/"
                                        to="/CompanyAppStandBy"
                                    ></Redirect>
                                )}
                                {member.companyNum === -1 && (
                                    <Route
                                        path="/CompanyAppStandBy"
                                        component={() => (
                                            <CompanyAppStandBy
                                                member={member}
                                                setMember={setMember}
                                            />
                                        )}
                                    />
                                )}
                            </Switch>
                        </HeaderEmptyLayout>
                    </BrowserRouter>
                </div>
            </SnackbarProvider>
        );
        //제조기업 화면
    } else if (member.companyType === 'M') {
        return (
            <SnackbarProvider
                maxSnack={3}
                autoHideDuration={SNACKBAR_TIME}
                style={{
                    fontSize: '3vw',
                }}
                className={classes.snackBar}
                action={(key) => SnackbarCloseButton(key)}
            >
                <div style={{ backgroundColor: '#ffffff' }}>
                    <BrowserRouter>
                        <Switch>
                            <Route
                                exact
                                path="/setting"
                                component={() => (
                                    <HeaderEmptyLayout>
                                        <Setting
                                            member={member}
                                            setMember={setMember}
                                            deleteMember={deleteMember}
                                        />
                                    </HeaderEmptyLayout>
                                )}
                            />
                            <Route
                                exact
                                path="/qna"
                                component={() => (
                                    <HeaderEmptyLayout>
                                        <QnA member={member} />
                                    </HeaderEmptyLayout>
                                )}
                            />
                            <Route
                                exact
                                path="/deleteUserAccount"
                                component={() => (
                                    <HeaderEmptyLayout isBackground={true}>
                                        <DeleteUserAccount
                                            member={member}
                                            setMember={setMember}
                                            deleteMember={deleteMember}
                                        />
                                    </HeaderEmptyLayout>
                                )}
                            />
                            <Layout>
                                <Route path="/">
                                    <Switch>
                                        <Redirect
                                            exact
                                            from="/"
                                            to="/CompanyInfo"
                                        ></Redirect>
                                        <Route
                                            path="/test"
                                            component={() => (
                                                <Test member={member} />
                                            )}
                                        />
                                        <Route
                                            path="/CompanyInfo"
                                            component={() => (
                                                <CompanyInfo member={member} />
                                            )}
                                        ></Route>
                                        <Route
                                            path="/CompanyAsset"
                                            component={() => (
                                                <CompanyAsset member={member} />
                                            )}
                                        ></Route>
                                        <Route
                                            path="/LoanList"
                                            component={() => (
                                                <LoanList member={member} />
                                            )}
                                        ></Route>
                                        <Route
                                            path="/CompanyAppList"
                                            component={() => (
                                                <CompanyAppList
                                                    member={member}
                                                />
                                            )}
                                        ></Route>
                                        <Route
                                            path="/CompanyEditMember"
                                            component={() => (
                                                <CompanyEditMember
                                                    member={member}
                                                />
                                            )}
                                        ></Route>
                                        <Route
                                            path="/LicenseList"
                                            component={() => (
                                                <LicenseList member={member} />
                                            )}
                                        ></Route>
                                        <Route
                                            path="/license/manual/:licenseNum"
                                            render={(props) => (
                                                <LicenseManual
                                                    {...props}
                                                    member={member}
                                                />
                                            )}
                                        ></Route>
                                        <Route
                                            path="/ProductionList"
                                            component={() => (
                                                <ProducitonList
                                                    member={member}
                                                />
                                            )}
                                        ></Route>
                                        <Route
                                            path="/ProductOrderList"
                                            component={() => (
                                                <ProductOrderList
                                                    member={member}
                                                />
                                            )}
                                        ></Route>
                                        <Route
                                            path="/MaterialPurchase"
                                            component={() => (
                                                <MaterialPurchase
                                                    member={member}
                                                />
                                            )}
                                        ></Route>
                                        <Route
                                            path="/OrderList"
                                            component={() => (
                                                <MaterialOrderList
                                                    member={member}
                                                />
                                            )}
                                        ></Route>
                                        <Route
                                            path="/OrderSheet/:orderNum"
                                            component={() => (
                                                <MaterialOrderSheet
                                                    member={member}
                                                />
                                            )}
                                        ></Route>
                                        <Route
                                            path="/ProductList"
                                            component={() => (
                                                <ProductList member={member} />
                                            )}
                                        ></Route>
                                        <Route
                                            path="/Manual"
                                            component={() => <ManualView />}
                                        />
                                    </Switch>
                                </Route>
                            </Layout>
                        </Switch>
                    </BrowserRouter>
                </div>
            </SnackbarProvider>
        );
        //유통기업 화면
    } else if (member.companyType === 'D') {
        return (
            <SnackbarProvider
                maxSnack={3}
                autoHideDuration={SNACKBAR_TIME}
                style={{
                    fontSize: '3vw',
                }}
                className={classes.snackBar}
                action={(key) => SnackbarCloseButton(key)}
            >
                <div style={{ backgroundColor: '#ffffff' }}>
                    <BrowserRouter>
                        <Switch>
                            <Route
                                exact
                                path="/setting"
                                component={() => (
                                    <HeaderEmptyLayout>
                                        <Setting
                                            member={member}
                                            setMember={setMember}
                                            deleteMember={deleteMember}
                                        />
                                    </HeaderEmptyLayout>
                                )}
                            />
                            <Route
                                exact
                                path="/qna"
                                component={() => (
                                    <HeaderEmptyLayout>
                                        <QnA member={member} />
                                    </HeaderEmptyLayout>
                                )}
                            />
                            <Route
                                exact
                                path="/deleteUserAccount"
                                component={() => (
                                    <HeaderEmptyLayout isBackground={true}>
                                        <DeleteUserAccount
                                            member={member}
                                            setMember={setMember}
                                            deleteMember={deleteMember}
                                        />
                                    </HeaderEmptyLayout>
                                )}
                            />
                            <Layout isDistribution={true}>
                                <Route path="/">
                                    <Switch>
                                        <Redirect
                                            exact
                                            from="/"
                                            to="/CompanyInfo"
                                        ></Redirect>
                                        <Route
                                            path="/test"
                                            component={() => (
                                                <Test member={member} />
                                            )}
                                        />
                                        <Route
                                            path="/CompanyInfo"
                                            component={() => (
                                                <CompanyInfo member={member} />
                                            )}
                                        ></Route>
                                        <Route
                                            path="/CompanyAsset"
                                            component={() => (
                                                <CompanyAsset member={member} />
                                            )}
                                        ></Route>
                                        <Route
                                            path="/QuestList"
                                            component={() => (
                                                <QuestList member={member} />
                                            )}
                                        ></Route>
                                        <Route
                                            path="/LoanList"
                                            component={() => (
                                                <LoanList member={member} />
                                            )}
                                        ></Route>
                                        <Route
                                            path="/CompanyAppList"
                                            component={() => (
                                                <CompanyAppList
                                                    member={member}
                                                />
                                            )}
                                        ></Route>
                                        <Route
                                            path="/CompanyEditMember"
                                            component={() => (
                                                <CompanyEditMember
                                                    member={member}
                                                />
                                            )}
                                        ></Route>
                                        <Route
                                            path="/MaterialSale"
                                            component={() => (
                                                <MaterialSale member={member} />
                                            )}
                                        ></Route>
                                        <Route
                                            path="/MaterialSaleList/:orderNum"
                                            component={() => (
                                                <MaterialSaleSheet
                                                    member={member}
                                                />
                                            )}
                                        ></Route>
                                        <Route
                                            path="/MaterialList"
                                            component={() => (
                                                <MaterialList member={member} />
                                            )}
                                        />
                                        <Route
                                            path="/ProductList"
                                            component={() => (
                                                <ProductPurchaseList
                                                    member={member}
                                                />
                                            )}
                                        />
                                        <Route
                                            path="/ProductPurchase"
                                            component={() => (
                                                <ProductPurchase
                                                    member={member}
                                                />
                                            )}
                                        />
                                        <Route
                                            path="/ProductOrderList2"
                                            component={() => (
                                                <ProductOrderList2
                                                    member={member}
                                                />
                                            )}
                                        />
                                        <Route
                                            path="/MaterialPurchase"
                                            component={() => (
                                                <MaterialPurchase
                                                    member={member}
                                                />
                                            )}
                                        ></Route>
                                        <Route
                                            path="/OrderList"
                                            component={() => (
                                                <MaterialOrderListTwo
                                                    member={member}
                                                />
                                            )}
                                        ></Route>
                                        <Route
                                            path="/OrderSheet/:orderNum"
                                            component={() => (
                                                <MaterialOrderSheet
                                                    member={member}
                                                />
                                            )}
                                        ></Route>
                                        <Route
                                            path="/materialLoanList"
                                            component={() => (
                                                <MaterialLoanList
                                                    member={member}
                                                />
                                            )}
                                        ></Route>

                                        <Route
                                            path="/materialLoan"
                                            component={() => (
                                                <MaterialLoan member={member} />
                                            )}
                                        ></Route>
                                        <Route
                                            path="/materialLoanSheet/:loanNum"
                                            component={() => (
                                                <MaterialLoanSheet
                                                    member={member}
                                                />
                                            )}
                                        ></Route>
                                    </Switch>
                                </Route>
                            </Layout>
                        </Switch>
                    </BrowserRouter>
                </div>
            </SnackbarProvider>
        );
    }

    return (
        <SnackbarProvider
            maxSnack={3}
            autoHideDuration={SNACKBAR_TIME}
            style={{
                fontSize: '3vw',
            }}
            className={classes.snackBar}
            action={(key) => SnackbarCloseButton(key)}
        >
            <div style={{ backgroundColor: '#ffffff' }}>
                <BrowserRouter>
                    <Switch>
                        <Route
                            exact
                            path="/setting"
                            component={() => (
                                <Setting
                                    member={member}
                                    setMember={setMember}
                                    deleteMember={deleteMember}
                                />
                            )}
                        />
                        <Route
                            exact
                            path="/qna"
                            component={() => <QnA member={member} />}
                        />
                        <Route
                            exact
                            path="/deleteUserAccount"
                            component={() => (
                                <DeleteUserAccount
                                    member={member}
                                    setMember={setMember}
                                    deleteMember={deleteMember}
                                />
                            )}
                        />
                        <Route path="/">
                            <HeaderBar />
                            <Switch>
                                <Redirect
                                    exact
                                    from="/"
                                    to="/CompanyInfo"
                                ></Redirect>
                                <Route
                                    path="/test"
                                    component={() => <Test member={member} />}
                                />
                                <Route
                                    path="/CompanyInfo"
                                    component={() => (
                                        <CompanyInfo member={member} />
                                    )}
                                ></Route>
                                <Route
                                    path="/LoanList"
                                    component={() => (
                                        <LoanList member={member} />
                                    )}
                                ></Route>
                                <Route
                                    path="/CompanyAppList"
                                    component={() => (
                                        <CompanyAppList member={member} />
                                    )}
                                ></Route>
                                <Route
                                    path="/LicenseList"
                                    component={() => (
                                        <LicenseList member={member} />
                                    )}
                                ></Route>
                                <Route
                                    path="/license/manual/:licenseNum"
                                    component={LicenseManual}
                                ></Route>
                                <Route
                                    path="/MaterialPurchase"
                                    component={() => (
                                        <MaterialPurchase member={member} />
                                    )}
                                ></Route>
                                <Route
                                    path="/OrderList"
                                    component={() => (
                                        <MaterialOrderList member={member} />
                                    )}
                                ></Route>
                                <Route
                                    path="/order/sheet/:orderNum"
                                    component={MaterialOrderSheet}
                                ></Route>

                                <Route
                                    path="/ProductSale"
                                    component={() => (
                                        <ProductSale member={member} />
                                    )}
                                ></Route>
                                <Route
                                    path="/Manual"
                                    component={() => <ManualView />}
                                />
                            </Switch>
                        </Route>
                    </Switch>
                </BrowserRouter>
            </div>
        </SnackbarProvider>
    );
}

export default App;
